import { createAsyncThunk } from "@reduxjs/toolkit";
import { type AssignParams } from "../../../domain/entities/assignment-queue";
import { type RouteAssignmentDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const assignRequest = createAsyncThunk<
  void,
  AssignParams,
  { dispatch: RouteAssignmentDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.ASSIGN_REQUEST, async (params, { extra }) => {
  await extra.routeAssignmentRepo.assign(params);
});
